export default __webpack_public_path__ + "static/media/ms.2418cb74.svg";